(() => {
  'use strict';
  const tiers = [
    { threshold: 3900, variantId: 43616650362947, title: 'Free Random Beyblade' },
    { threshold: 6500, variantId: 43616650395715, title: 'Free Launcher' },
    { threshold: 12500, variantId: 43616650428483, title: 'Free 4-Pack & Launcher' },
    { threshold: 18900, variantId: 43616650461251, title: 'Free Mini Stadium' }
  ];
  const giftIds = new Set(tiers.map((tier) => tier.variantId));
  let syncing = false;
  let timer;
  const cartUrl = () => window.routes?.cart_url || '/cart';
  const eligible = (item) => {
    if (giftIds.has(Number(item.variant_id))) return false;
    const text = [item.product_type, item.product_title, item.title, item.vendor, item.handle, item.url].filter(Boolean).join(' ').toLowerCase();
    return /bey\s*blade|takara tomy|hasbro beyblades|burst series|metal series|\bx series\b|beyblade x/.test(text);
  };
  const render = (cart) => document.querySelectorAll('[data-tts-free-gifts]').forEach((panel) => {
    const subtotal = cart.items.reduce((sum, item) => sum + (eligible(item) ? item.line_price : 0), 0);
    const next = tiers.find((tier) => subtotal < tier.threshold);
    const message = panel.querySelector('[data-tts-free-gift-message]');
    const fill = panel.querySelector('[data-tts-free-gift-fill]');
    if (message) message.textContent = next ? `$${((next.threshold - subtotal) / 100).toFixed(2)} in Beyblade items away from ${next.title}.` : "All Tyson's Toy Store rewards unlocked.";
    if (fill) fill.style.width = `${Math.min(100, subtotal / tiers.at(-1).threshold * 100)}%`;
    panel.querySelectorAll('[data-tts-free-gift-marker]').forEach((marker) => marker.classList.toggle('is-unlocked', subtotal >= tiers.find((tier) => tier.variantId === Number(marker.dataset.variantId)).threshold));
    const nextMarker = panel.querySelector(`[data-variant-id="${next?.variantId}"]`);
    panel.querySelectorAll('.is-next').forEach((marker) => marker.classList.remove('is-next'));
    nextMarker?.classList.add('is-next');
  });
  async function getCart() { return fetch(`${cartUrl()}.js`, { credentials: 'same-origin' }).then((response) => response.json()); }
  async function changeGift(id, quantity) {
    const response = await fetch(`${cartUrl()}/${quantity ? 'add' : 'change'}.js`, {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(quantity ? { id, quantity: 1, properties: { _tts_free_gift: 'true' } } : { id, quantity: 0 })
    });
    if (!response.ok) throw new Error(`Unable to update free gift (${response.status})`);
    return response.json();
  }
  async function refreshSections(cart) {
    const response = await fetch(`${cartUrl()}?sections=cart-drawer,main-cart-items,main-cart-footer,cart-icon-bubble`, { credentials: 'same-origin' });
    const sections = await response.json();
    const drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer']) {
      if (cart.item_count === 0) {
        const source = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        const target = drawer.querySelector('#CartDrawer');
        if (source && target) target.innerHTML = source.innerHTML;
        drawer.classList.add('is-empty');
        drawer.querySelector('.drawer__inner')?.classList.add('is-empty');
        drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', drawer.close.bind(drawer));
      } else {
        drawer.renderContents({ sections });
      }
    }
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (cartIcon && sections['cart-icon-bubble']) {
      cartIcon.innerHTML = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').body.innerHTML;
    }
    [['main-cart-items', '#main-cart-items .js-contents'], ['main-cart-footer', '.js-contents']].forEach(([id, selector]) => {
      const target = document.querySelector(selector);
      if (!target || !sections[id]) return;
      const source = new DOMParser().parseFromString(sections[id], 'text/html').querySelector(selector);
      if (source) target.innerHTML = source.innerHTML;
    });
  }
  async function sync() {
    if (syncing) return; syncing = true;
    try {
      let cart = await getCart(); const subtotal = cart.items.reduce((sum, item) => sum + (eligible(item) ? item.line_price : 0), 0); let changed = false;
      for (const tier of tiers) {
        const lines = cart.items.filter((line) => Number(line.variant_id) === tier.variantId);
        const qualifies = subtotal >= tier.threshold;
        const correctLine = lines.length === 1 && lines[0].quantity === 1 && lines[0].properties?._tts_free_gift === 'true';
        if ((!qualifies && lines.length) || (qualifies && !correctLine)) {
          for (const line of lines) await changeGift(line.key, false);
          if (qualifies) await changeGift(tier.variantId, true);
          changed = true;
        }
      }
      if (changed) { cart = await getCart(); await refreshSections(cart); }
      render(cart);
    } catch (error) { console.error('TTS free-gift sync failed', error); } finally { syncing = false; }
  }
  const schedule = () => { clearTimeout(timer); timer = setTimeout(sync, 300); };
  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('cart:refresh', schedule);
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('theme:product:add', schedule);
  document.addEventListener('theme:line-item:change', schedule);
  document.addEventListener('submit', () => setTimeout(schedule, 450), true);
  window.addEventListener('pageshow', schedule);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  }
})();
